import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import intervalPlural from 'i18next-intervalplural-postprocessor';
import packJson from '../../package.json';
import { initReactI18next } from 'react-i18next';

export const languages = [
  {
    name: 'English',
    value: 'en-US',
    code: 'en',
  },
  {
    name: 'German',
    value: 'de-DE',
    code: 'de',
  },
];

export const translateItem = (item, langKey, lanSubKey) => {
  const tname = `${lanSubKey}_${String(item).toLowerCase()}`.replace(' ', '_');
  return i18n.t([`${langKey}.${tname}`, item]);
};

const fallbackLng = ['en', 'de'];
const supportedLngs = languages.map(item => item.code);

const configs = {
  fallbackLng,
  supportedLngs,
  nonExplicitSupportedLngs: true,
  cleanCode: true,
  initImmediate: false,
  load: 'languageOnly',
  interpolation: {
    escapeValue: false,
  },
  detection: {
    lookupQuerystring: 'lang',
    lookupCookie: 'lang',
    lookupLocalStorage: 'lang',
    order: ['localStorage', 'querystring', 'cookie', 'sessionStorage', 'navigator'],
    caches: ['localStorage', 'cookie'],
  },
  backend: {
    loadPath: '/locales/{{lng}}/translation.json',
    queryStringParams: { v: packJson.version },
  },
};

i18n
  .use(Backend)
  .use(intervalPlural)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init(configs);
